module.exports = __webpack_public_path__ + "img/bi_img.e404b298.png";